import { authApi } from '@repo/api-client';
import { setToken } from '@repo/api-client/lib/auth';
import { useEffect } from 'react';

export function Google() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    document.body.appendChild(script);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).handleCredentialResponse = handleCredentialResponse;
  }, []);

  async function handleCredentialResponse({ credential }: { credential: string }) {
    const { access } = await authApi.loginWithGoogle(credential);
    setToken(access);
    window.location.href = '/';
  }

  return (
    <>
      <div
        id="g_id_onload"
        data-auto_prompt="false"
        data-callback="handleCredentialResponse"
        data-client_id={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}
      ></div>
      <div className="g_id_signin"></div>
    </>
  );
}
